import { render, staticRenderFns } from "./LicensePlate.vue?vue&type=template&id=45b36db1&scoped=true&"
import script from "./LicensePlate.vue?vue&type=script&lang=js&"
export * from "./LicensePlate.vue?vue&type=script&lang=js&"
import style0 from "./LicensePlate.vue?vue&type=style&index=0&id=45b36db1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b36db1",
  null
  
)

export default component.exports